<div fxLayout="row" fxLayoutGap="20px" class="summary-container">
    <ng-content></ng-content>
</div>
